
const WhiteSpacePage = () => {
    return (
        <div>창을 닫아주세요.</div>
    )
}

export default WhiteSpacePage